import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';
import Form from './Form';

export default function Index() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="text-right">
      <Button onClick={() => setShowModal(true)} bsStyle="primary">
        Add Note
      </Button>

      <ModalWithoutTitle
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Form closeForm={() => setShowModal(false)} />
      </ModalWithoutTitle>
    </div>
  );
}
